




















import Vue from "vue";
import { RoleEnum } from "@/graphql/generatedTypes/globalTypes";

export default Vue.extend({
  name: "AdminPortalTable",
  methods: {
    userIsAdmin: function(): boolean {
      return this.$authRepository.getCurrentUser()?.imgRole === RoleEnum.ADMIN;
    }
  },
  props: {
    tableOptions: {} as any
  }
});
